import { render } from "./settings.vue?vue&type=template&id=dcae058e"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"
script.render = render

export default script